






export default {
  name: 'AppProgressSpinner',
};
